import { Icon } from '@iconify/react';
import carFilled from '@iconify/icons-ant-design/car-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

export default function AppCarnum(props) {
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={carFilled} width={25} height={25} />
      </IconWrapperStyle>
      <Typography variant="h3">
        {props.TOTAL}
        {props.unit}
      </Typography>
      <Typography variant="h4" sx={{ opacity: 0.72 }}>
        {props.title}
      </Typography>
    </RootStyle>
  );
}
